import { render, staticRenderFns } from "./TransactionStatsSection.vue?vue&type=template&id=38e0d998&scoped=true"
import script from "./TransactionStatsSection.vue?vue&type=script&lang=js"
export * from "./TransactionStatsSection.vue?vue&type=script&lang=js"
import style0 from "./TransactionStatsSection.vue?vue&type=style&index=0&id=38e0d998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0d998",
  null
  
)

export default component.exports